import React, { useState } from 'react'
import { rootAction } from '../../../redux/reducer/rootReducer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Privileges } from '../../../util/PrivilegeConstants';
import { isClubOwner, isCoach } from '../../../util/UserRoles';
import { FaCheckCircle, FaMinus, FaPlus } from 'react-icons/fa';
import { Button } from '@mui/material';
import { SubscriptionAPI } from '../../../api/SubscriptionAPI';
import { SiSitepoint } from 'react-icons/si';
import { CiEdit } from 'react-icons/ci';

const SubDetailsCard = ({ subscriptionDetails,userInfo, defaultPayCard, startLoading, finishLoading, selectedClub, resumeSubscription, privileges }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [totalCourt, setTotalCourt] = useState(subscriptionDetails?.subscriptionQty ?? 0);
    const [openEdit, setOpenEdit] = useState(false);

    const increaseCourtNo = () => {
        setTotalCourt(totalCourt + 1);
    };
    const decreaseCourtNo = () => {
        if (totalCourt <= 1) {
            return;
        }
        setTotalCourt(totalCourt - 1);
    };


    const handleSubUpdate = async () => {
        try {
            startLoading("loading3")
            const subUpateInfo = {
                userId: userInfo.userId,
                clubId: selectedClub.clubId,
                subQuantity: totalCourt,
                subscriptionId: subscriptionDetails?.subscriptionStripeId
            }
            const result = await SubscriptionAPI.updateSubscription(subUpateInfo);
            dispatch(rootAction.setWarningMessage({id:Date.now(),type: 'success', content: 'Your subscription is updated successfully' }));
            setOpenEdit(false);
        } catch (error) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please contact customer support!' }));
        }finally{
            finishLoading("loading3");
        }
    }


    return (
        <div className="admin-sub-details-card">
            <div className="free_trial-badge">
                {subscriptionDetails?.status === 'trialing' && <p>free trial end in 30 days</p>}
                {subscriptionDetails?.status !== 'trialing' && <p>{subscriptionDetails?.status}</p>}
            </div>
            <p className="admin-sub-details-card-title">Your plan details</p>
            {subscriptionDetails?.planFor === "CLUB_RESERVATION" ?
                <p className="admin-sub-details-balance">
                    ${(subscriptionDetails?.subscriptionPricePerUnit / 100)} <span>per court
                    </span>
                </p>
                :
                <p className="admin-sub-details-balance">
                    ${(subscriptionDetails?.subscriptionPricePerUnit / 100)} <span>per {subscriptionDetails?.subscriptionInterval}

                    </span>
                </p>}

            {defaultPayCard &&
                <p className="admin-sub-details-account">
                    <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                    >
                        <rect width="22" height="16" x="1" y="4" rx="2" ry="2"></rect>
                        <path d="M1 10h22"></path>
                    </svg>
                    Account: **** **** **** {defaultPayCard?.last4Digits}
                </p>}
            <svg
                className="admin-sub-details-dollar-sign"
                width="40"
                height="40"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
            >
                <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
            {(subscriptionDetails?.status === "active" && subscriptionDetails?.planFor === "CLUB_RESERVATION") &&
                <div className="admin_subscriptionDetails_court_no">
                    <p className="admin_subscriptionDetails_court_no_data">
                        <SiSitepoint className="total_court_no_icon" />
                        Total Court:
                        <span>{totalCourt}</span>
                        {privileges?.MANAGE_PLATFORM_PLAN?.includes(Privileges.MODIFY) &&
                            <CiEdit
                                onClick={() => setOpenEdit(!openEdit)}
                                className="total_court_no_edit_icon"
                            />}
                    </p>
                    <div
                        className={
                            openEdit
                                ? "admin_subscriptionDetails_court_no_edit_input active"
                                : "admin_subscriptionDetails_court_no_edit_input"
                        }
                    >
                        <div className="select_court_no_input_edit">
                            <button onClick={decreaseCourtNo}>
                                <FaMinus className="select_court_no_input_icon" />
                            </button>
                            <span id="total_court_no">{totalCourt}</span>
                            <button onClick={increaseCourtNo}>
                                <FaPlus className="select_court_no_input_icon" />
                            </button>
                        </div>
                        <div className="court_plan_edit_purchase_btn">
                            <Button fullWidth variant="contained" onClick={handleSubUpdate}>
                                Save
                            </Button>
                        </div>
                    </div>
                </div>}

            {subscriptionDetails?.status === "paused" &&
                <div className="admin_subscriptionDetails_court_no">
                    <p className="free_trial_end_notify">
                        {selectedClub?.clubName}, you haven't added a payment method yet, so your subscription has been put on hold. To continue, please add a card and click Resume.
                    </p>
                </div>
            }
            <div className="plan_features">
                {subscriptionDetails?.features && Object.values(subscriptionDetails?.features).filter(data => data != null).map((val, index) =>
                    <p key={index}>
                        <FaCheckCircle className="subscription_features_icon" />{val}
                    </p>
                )}
            </div>
            {(subscriptionDetails?.status === "paused" && isClubOwner(userInfo)) &&
                <>
                    {defaultPayCard
                        ?
                        <button onClick={() => resumeSubscription(subscriptionDetails?.subscriptionStripeId)} className="subscription-resume-btn">Resume</button>
                        :
                        <button
                            onClick={() => {
                                dispatch(rootAction.setActiveTab({ payment: true }));
                                navigate('/payment-details');
                            }}
                            className="subscription-resume-btn"
                        >add card</button>}
                </>
            }


        </div>

    )
}

export default SubDetailsCard